<app-model-view></app-model-view>
<app-loading [class.visible]="loading"></app-loading>
<app-help fxLayout="column" *ngIf="!sharedLinkVersion" class="hidden"></app-help>
<app-summary-dialog fxLayout="column" *ngIf="sharedLinkVersion" class="hidden"></app-summary-dialog>
<app-step-container *ngIf="!sharedLinkVersion" class="hidden"></app-step-container>
<app-close *ngIf="!sharedLinkVersion"></app-close>
<app-conflicts-panel class="hidden"></app-conflicts-panel>
